import moment from "moment";
import { ColumnProps, useTheme } from "@monolith-forensics/monolith-ui";
import EvidenceNumberCell from "@/components/Evidence/EvidenceNumberCell";
import { TimelineEvent } from "../TimelineEvents.types";
import { monolithMoment } from "@/utils/date-format";

const TimelineEvidenceCell = ({
  evidence,
}: {
  evidence: TimelineEvent["source_evidence"];
}) => {
  const theme = useTheme();

  return (
    <EvidenceNumberCell rowData={evidence} color={theme.palette.primary.main} />
  );
};

export const TimelineEventDefinitions: ColumnProps[] = [
  {
    dataField: "uuid",
    caption: "UUID",
    visible: false,
  },
  {
    dataField: "timestamp",
    caption: "Timestamp (UTC)",
    width: 200,
    render: ({ rowData }: { rowData: TimelineEvent }) => {
      return moment.utc(rowData.timestamp).format("YYYY-MM-DD HH:mm:ss.SSS z");
    },
  },
  {
    dataField: "created_on",
    caption: "Created On",
    visible: false,
    render: ({ rowData }: { rowData: TimelineEvent }) => {
      if (!rowData.created_on) {
        return "";
      }
      return monolithMoment({
        timestamp: rowData.created_on,
        includeTime: true,
        includeMs: true,
        includeZone: true,
      });
    },
  },
  {
    dataField: "updated_on",
    caption: "Updated On",
    visible: false,
    render: ({ rowData }: { rowData: TimelineEvent }) => {
      if (!rowData.updated_on) {
        return "";
      }
      return monolithMoment({
        timestamp: rowData.updated_on,
        includeTime: true,
        includeMs: true,
        includeZone: true,
      });
    },
  },
  {
    dataField: "created_by",
    caption: "Created By",
    visible: false,
    render: ({ rowData }: { rowData: TimelineEvent }) =>
      rowData.created_by?.full_name,
  },
  {
    dataField: "event_name",
    caption: "Event Name",
  },
  {
    dataField: "event_type",
    caption: "Event Type",
    render: ({ rowData }: { rowData: TimelineEvent }) =>
      rowData.event_type?.name,
  },
  {
    dataField: "artifact",
    caption: "Artifact",
    render: ({ rowData }: { rowData: TimelineEvent }) => rowData.artifact?.name,
  },
  {
    dataField: "account",
    caption: "User Account",
    render: ({ rowData }: { rowData: TimelineEvent }) => rowData.account?.name,
  },
  {
    dataField: "source_evidence",
    caption: "Source Evidence",
    render: ({ rowData }: { rowData: TimelineEvent }) =>
      rowData.source_evidence ? (
        <TimelineEvidenceCell evidence={rowData.source_evidence} />
      ) : null,
  },
  {
    dataField: "target_evidence",
    caption: "Target Evidence",
    visible: false,
    render: ({ rowData }: { rowData: TimelineEvent }) =>
      rowData.target_evidence ? (
        <TimelineEvidenceCell evidence={rowData.target_evidence} />
      ) : null,
  },
  {
    dataField: "mitre_tactic",
    caption: "MITRE Tactic",
    visible: false,
    render: ({ rowData }: { rowData: TimelineEvent }) =>
      rowData.mitre_tactic?.name,
  },
  {
    dataField: "mitre_technique",
    caption: "MITRE Technique",
    visible: false,
    render: ({ rowData }: { rowData: TimelineEvent }) =>
      rowData.mitre_technique?.name,
  },
  {
    dataField: "description",
    caption: "Description",
    visible: false,
  },
];
